module.exports = __webpack_public_path__ + "static/media/school-solid.014b06bf.svg";